<template>
  <v-select
    :items="types"
    item-text="name"
    item-value="id"
    v-model="currentType"
    hide-selected
    placeholder="Assign type"
    :label="label"
    :readonly="readonly"
    dense
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'select-bill-type',
  data: () => ({
    types: [
      { id: 'invoice', name: 'Invoice' },
      { id: 'credit', name: 'Credit' },
      { id: 'referral_invoice', name: 'Referral Invoice' },
      { id: 'referral_credit', name: 'Referral Credit' }
    ]
  }),
  props: ['billType', 'billId', 'label', 'readonly'],
  computed: {
    currentType: {
      get() {
        return this.billType;
      },
      set(type) {
        this.$emit('changed', type);
        if (this.billId !== null) {
          this.updateBill({
            id: this.billId,
            updates: {
              type: type
            }
          });
        }
      }
    }
  },
  methods: mapActions(['updateBill'])
};
</script>

<style scoped></style>
